var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goTop",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"goTopImage",attrs:{"src":require("@/assets/go-top.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }